import React, { useEffect, useRef, useState } from 'react';
import { BrowserQRCodeReader, IScannerControls } from '@zxing/browser';
import { Box, Button, Container, Stack } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import MODAL_TABLE from '../../../../main_components/modal/modal_Table';
import { bussines_partnert_put_qr } from '../../../../services/businesspartners/businesspartners';

const getBackendErrorMessage = (error: any): string => {
  const errorMessage = error?.response?.data?.errorMessage;
  return (
    errorMessage?.es ||
    errorMessage?.en ||
    error?.response?.data?.message ||
    "Ocurrió un error al procesar la información del QR."
  );
};

const CustomQR: React.FC = () => {
  
  const videoRef = useRef<HTMLVideoElement>(null);
  const codeReaderRef = useRef<BrowserQRCodeReader | null>(null);
  const controlsRef = useRef<IScannerControls | null>(null);
  const [mediaStream, setMediaStream] = useState<MediaStream | null>(null);
  const [modalT, setModalT] = useState(false);
  const [messgeNotFound, setMessgeNotFound] = useState("");
  const hasScannedRef = useRef(false);
  const [enableButton, setEnableButton] = useState(false);
  const [enableButtonNotFound, setEnableButtonNotFound] = useState(false);
  const [scanning, setScanning] = useState(true);

  const [dataResponse, setdataResponse] = useState<any>({});

  const navigate = useNavigate();

  
const stopAll = () => {
  try {
    controlsRef.current?.stop();
  } catch {}
  controlsRef.current = null;
  const stream = (videoRef.current?.srcObject as MediaStream) || mediaStream || null;
  if (stream) {
    stream.getTracks().forEach(track => track.stop());
  }
  if (videoRef.current) {
    videoRef.current.srcObject = null;
  }
  setMediaStream(null);
};

  
const startScanner = async () => {
  if (!videoRef.current) return;
  hasScannedRef.current = false; 
  const codeReader = new BrowserQRCodeReader();
  codeReaderRef.current = codeReader;

  try {
    await codeReader.decodeFromVideoDevice(
      undefined,
      videoRef.current,
      async (result, error, controls) => {
        if (!controlsRef.current) controlsRef.current = controls;
        if (result) {

          if (hasScannedRef.current) return;
          hasScannedRef.current = true;

          try { controlsRef.current?.stop(); } catch {}
          const stream = (videoRef.current?.srcObject as MediaStream) || mediaStream || null;
          if (stream) { stream.getTracks().forEach(t => t.stop()); }
          if (videoRef.current) videoRef.current.srcObject = null;
          setMediaStream(null);

          await handle_response_url(result.getText());

        }
      }
    );

    setTimeout(() => {
      if (videoRef.current?.srcObject) {
        const stream = videoRef.current.srcObject as MediaStream;
        setMediaStream(stream);
      }
    }, 300);
  } catch (err) {
    console.error("Error iniciando escáner:", err);
  }
};

  const handle_response_url = async (url: string) => {
    setModalT(true);
    setEnableButton(false);
    setEnableButtonNotFound(false);
    try {
      const response = await bussines_partnert_put_qr({ url });
      console.log('Respuesta del servidor:', response);
      setMessgeNotFound("El socio de negocios fue actualizado correctamente en el sistema.");
      setEnableButton(true);

    } catch (error: any) {
      console.log(error);
      const status = error?.response?.status ?? error?.status;
      if (status === 404 && error.response?.data) {
        const data = error.response.data;
        const bp = data.business_partner || {};
        const addr = data.address || {};

        const filledObject = {
          code: "",
          business_partner: bp.business_partner ?? null,
          rfc: bp.rfc ?? null,
          paymethod: "01",
          allow_invoicing: false,
          name: bp.name ?? null,
          force_code: false,
          first_last_name: bp.first_last_name ?? null,
          second_last_name: bp.second_last_name ?? null,
          capital_regime: bp.capital_regime ?? null,
          cfdi_use: "G03",
          tax_residence: null,
          num_reg_id_trib: null,
          metodo_pago: "PUE",
          tax_regime: bp.tax_regime ?? "616",
          email: bp.email ?? null,
          enable: true,
          person_type: bp.rfc.length === 12 ? "MORAL" : "FISICA",
          zip_code: addr.zip_code ?? null,
          street: addr.street ?? null,
          city: addr.city ?? null,
          outdoor_number: addr.outdoor_number ?? null,
          inside_number: addr.inside_number ?? null,
          state: addr.state ?? "VERACRUZ DE IGNACIO DE LA LLAVE",
          reference: null,
          outer_code: null,
          account_number: null,
          id_accounting_account_fk: null,
          name_accounting_account: null,
          code_accounting_account: null,
          address_type: "FISCAL",
          country: "MÉXICO",
          town: null,
          subsidiary: "MATRIZ",
          neighborhood: addr.neighborhood ?? null,
          partner_type: "PROPIO",
          credit_days: null,
          business_partner_type: "CLIENTE",
        };

        setdataResponse(filledObject);
        setMessgeNotFound(getBackendErrorMessage(error));
        setEnableButtonNotFound(true);
      } else {
        setMessgeNotFound(getBackendErrorMessage(error));
        setEnableButton(false);
        setEnableButtonNotFound(false);
      }

    } finally {
      setModalT(false);
      stopAll();
    }
  };


  
  const handle_redirect_page = () => {

    setTimeout(() => navigate('/CUSTOM_QR_PARTNER', {
      state: { myObject: dataResponse }
    }), 50);
  };

  const handle_reload_page = () => {
    stopAll();
    setTimeout(() =>  window.location.href = "BUSSINES_PARTNER_TS", 50);
  };

  useEffect(() => {
    if (scanning) {
      startScanner();
    }
    return () => {
      stopAll();// 🔒 Seguridad por si se desmonta
    };
  }, [scanning]);


useEffect(() => {
  const onPageShow = (e: PageTransitionEvent) => {
    if (e.persisted) {
      stopAll();
      setScanning(true);
    }
  };
  window.addEventListener('pageshow', onPageShow as any);
  return () => {
    window.removeEventListener('pageshow', onPageShow as any);
  };
}, []);



  return (
    <Container maxWidth="sm">
      <MODAL_TABLE open={false} message={''} message2={''} modalGeneral={false} modalT={modalT} />

      <Stack spacing={2} sx={{ py: 2 }}>
        <Box
          sx={{
            position: 'relative',
            border: '2px solid #e0e0e0',
            borderRadius: 2,
            overflow: 'hidden',
          }}
        >
          {messgeNotFound === "" ? <video ref={videoRef} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <div></div>}
        </Box>

        <Stack direction="column" spacing={2}>
          <p>{messgeNotFound}</p>

          {enableButtonNotFound && (
            <Button
              fullWidth
              size="large"
              variant="contained"
              sx={{
                bgcolor: '#5B21B6',
                '&:hover': {
                  bgcolor: '#4C1D95'
                }
              }}
              onClick={handle_redirect_page}
            >
              REGISTRAR NUEVO SOCIO
            </Button>
          )}

          {enableButton && (
            <Button
              fullWidth
              size="large"
              variant="contained"
              sx={{
                bgcolor: '#059669',
                '&:hover': {
                  bgcolor: '#047857'
                }
              }}
              onClick={handle_reload_page}
            >
              ACTUALIZAR TABLA
            </Button>
          )}
        </Stack>
      </Stack>
    </Container>
  );
};

export default CustomQR;
